import { render, staticRenderFns } from "./PlanOrderList.vue?vue&type=template&id=a8bf1dce"
import script from "./PlanOrderList.vue?vue&type=script&lang=js"
export * from "./PlanOrderList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports